const visibleFields = [
  {
    type: "slider",
    values: [
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_title",
      "content_index_web_pic",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_link_text",
      "data_translations_ar-SA_languages_code",
      "data_effect",
      "data_speed",
      "iconName",
    ],
  },
  {
    type: "title",
    values: [
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
    ],
  },
  {
    type: "category_list",
    values: [
      "content_index_iconName",
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_languages_code",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_languages_code",
      "content_index_translations_tr-TR_title",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "icon_name",
    ],
  },
  {
    type: "projects_list",
    values: [
      "content_index_order",
      "content_index_project_name",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "about_us",
    values: [
      "content_index_iconName",
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_languages_code",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_languages_code",
      "content_index_translations_tr-TR_title",
      "data_mobile_pic",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_title",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_title",
      "data_web_pic",
      "icon_name",
    ],
  },
  {
    type: "donations_type",
    values: [
      "content_index_iconName",
      "content_index_mobile_pic",
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_title",
      "content_index_web_pic",
      "data_translations_ar-SA_title",
      "data_translations_en-US_title",
      "data_translations_tr-TR_title",
      "icon_name",
    ],
  },
  {
    type: "blogs_list",
    values: [
      "content_index_order",
      "content_index_project_name",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "quotes",
    values: [
      "content_index_iconName",
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_title",
      "content_index_web_pic",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "rohingya_video",
    values: [
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_link",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_languages_code",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_languages_code",
      "data_web_pic",
      "icon_name",
    ],
  },
  {
    type: "rohingya_story",
    values: [
      "content_index_effect_id",
      "content_index_effect_name",
      "content_index_iconName",
      "content_index_mobile_pic",
      "content_index_order",
      "content_index_speed",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_title",
      "content_index_web_pic",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_link",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_languages_code",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_languages_code",
      "icon_name",
    ],
  },
  {
    type: "rohingya_timeline",
    values: [
      "content_index_effect_id",
      "content_index_effect_name",
      "content_index_iconName",
      "content_index_mobile_pic",
      "content_index_order",
      "content_index_speed",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_title",
      "content_index_web_pic",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_link",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_languages_code",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_languages_code",
      "icon_name",
    ],
  },
  {
    type: "rohingya_footer",
    values: [
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_link",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_languages_code",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_languages_code",
      "data_web_pic",
      "icon_name",
    ],
  },
  {
    type: "3ta2_background",
    values: [
      "data_mobile_pic",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_languages_code",
      "data_translations_en-US_title",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_title",
      "data_web_pic",
      "icon_name",
    ],
  },
  {
    type: "3ta2_info",
    values: [
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_languages_code",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_languages_code",
      "icon_name",
    ],
  },
  {
    type: "3ta2_steps",
    values: [
      "content_index_iconName",
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_languages_code",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_languages_code",
      "content_index_translations_tr-TR_title",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "reports",
    values: [
      "content_index_order",
      "content_index_project_name",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "faq",
    values: [
      "content_index_order",
      "content_index_project_name",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "partners",
    values: [
      "content_index_mobile_pic",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_title",
      "content_index_web_pic",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "leadership",
    values: [
      "content_index_mobile_pic",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_title",
      "content_index_web_pic",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "identity",
    values: [
      "content_index_iconName",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "todolist",
    values: [
      "content_index_order",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_title",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "icon_name",
    ],
  },
  {
    type: "data_with_image_content",
    values: [
      "content_index_order",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_title",
      "content_index_iconName",
      // "content_index_web_pic",
      "data_iconName",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_title",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_title",
      "icon_name",
    ],
  },
  {
    type: "data_with_table_content",
    values: [
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_languages_code",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_languages_code",
      "content_index_translations_tr-TR_title",
      "data_iconName",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_title",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_title",
      "icon_name",
    ],
  },
  {
    type: "contact_us",
    values: [
      "content_index_iconName",
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "data_translations_ar-SA_logo",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "content_index_translations_en-US_description",
      "content_index_translations_en-US_languages_code",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_languages_code",
      "content_index_translations_tr-TR_title",
      // "data_mobile_pic",
      "cannot_delete",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_languages_code",
      "data_translations_en-US_title",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_title",
      // "data_web_pic",
      "icon_name",
    ],
  },
  {
    type: "receipt",
    values: [
      "content_index_iconName",
      "content_index_order",
      // "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      // "content_index_translations_ar-SA_title",
      // "content_index_translations_en-US_description",
      "content_index_translations_en-US_languages_code",
      "content_index_translations_en-US_title",
      "content_index_translations_tr-TR_description",
      "content_index_translations_tr-TR_languages_code",
      "content_index_translations_tr-TR_title",
      "data_mobile_pic",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      "data_translations_en-US_description",
      "data_translations_en-US_languages_code",
      "data_translations_en-US_title",
      "data_translations_tr-TR_description",
      "data_translations_tr-TR_title",
      "data_web_pic",
      "icon_name",
    ],
  },
  {
    type: "footer",
    values: [
      "content_index_iconName",
      "content_index_order",
      "content_index_translations_ar-SA_description",
      "content_index_translations_ar-SA_languages_code",
      "content_index_translations_ar-SA_link",
      "content_index_translations_ar-SA_title",
      "data_mobile_pic",
      "data_translations_ar-SA_description",
      "data_translations_ar-SA_languages_code",
      "data_translations_ar-SA_title",
      // "data_web_pic",
      "icon_name",
      "data_translations_ar-SA_logo",
    ],
  },
];

const isFieldVisible = (fieldName, type) => {
  const fieldObj = visibleFields.find((f) => f.type === type);
  return fieldObj && fieldObj.values.includes(fieldName);
};

export default isFieldVisible;
